var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "saas-page profile-command-page" }, [
    _c("div", { staticClass: "saas-hero card-saas profile-command-hero" }, [
      _c("div", { staticClass: "saas-hero__main" }, [
        _c(
          "p",
          { staticClass: "saas-hero__crumb" },
          [
            _c("router-link", { attrs: { to: "/user" } }, [
              _vm._v(_vm._s(_vm.trans("user.user"))),
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "px-1" }, [_vm._v("/")]),
            _vm._v(" "),
            _c("span", [_vm._v(_vm._s(_vm.trans("user.avatar")))]),
          ],
          1
        ),
        _vm._v(" "),
        _c("h1", { staticClass: "saas-hero__title" }, [
          _vm._v(
            _vm._s(_vm.userForm.first_name) +
              " " +
              _vm._s(_vm.userForm.last_name)
          ),
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "profile-command-hero__subtitle" }, [
          _vm._v(_vm._s(_vm.trans("user.avatar"))),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "nk-block" }, [
      _c(
        "div",
        { staticClass: "card-saas card-saas--flush admin-user-profile-card" },
        [
          _c("div", { staticClass: "card-aside-wrap" }, [
            _c(
              "div",
              { staticClass: "card-content" },
              [
                _c("user-sidebar", { attrs: { menu: "avatar", id: _vm.id } }),
                _vm._v(" "),
                _c("div", { staticClass: "card-inner admin-user-form-inner" }, [
                  _c(
                    "div",
                    { staticClass: "nk-block" },
                    [
                      _c(
                        "div",
                        { staticClass: "nk-block-head admin-user-form-head" },
                        [
                          _c(
                            "h4",
                            { staticClass: "admin-user-section-title" },
                            [_vm._v(_vm._s(_vm.trans("user.avatar")))]
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c("upload-image", {
                        attrs: {
                          id: "user-avatar-" + _vm.id,
                          presentation: "avatar",
                          "upload-path": `/user/profile/avatar/${_vm.id}`,
                          "remove-path": `/user/profile/avatar/remove/${_vm.id}`,
                          "image-source": _vm.avatar.user,
                        },
                        on: {
                          uploaded: _vm.updateAvatar,
                          removed: _vm.updateAvatar,
                        },
                      }),
                    ],
                    1
                  ),
                ]),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "card-aside card-aside-right user-aside toggle-slide toggle-slide-right toggle-break-xxl",
                attrs: {
                  "data-content": "userAside",
                  "data-toggle-screen": "xxl",
                  "data-toggle-overlay": "true",
                  "data-toggle-body": "true",
                },
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "card-inner-group",
                    attrs: { "data-simplebar": "" },
                  },
                  [_c("user-summary", { attrs: { user: _vm.user } })],
                  1
                ),
              ]
            ),
          ]),
        ]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }